import { Link } from 'react-router-dom';
import { useState } from 'react';
import { IconChevronRight } from '../../lib/icons.tsx';
import type { Crumb } from '../../api/types.ts';

interface Props {
  crumbs: Crumb[];
  /** 라우트 접두 ('/files' 또는 '/ns/<id>') */
  base?: string;
  /** 브레드크럼에 드롭해서 상위 폴더로 이동시킬 수 있다 */
  onDropTo?: (path: string) => void;
}

export function Breadcrumb({ crumbs, onDropTo, base = '/files' }: Props) {
  const [dropTarget, setDropTarget] = useState<string | null>(null);

  return (
    <nav className="crumbs" aria-label="현재 위치">
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        return (
          <span key={crumb.path} className="row" style={{ gap: 2 }}>
            {index > 0 && <IconChevronRight size={14} className="crumbs__sep" />}
            <Link
              to={`${base}${crumb.path}`}
              className="crumbs__item"
              data-current={isLast}
              data-drop={dropTarget === crumb.path}
              onDragOver={(e) => {
                if (!onDropTo || isLast) return;
                e.preventDefault();
                setDropTarget(crumb.path);
              }}
              onDragLeave={() => { setDropTarget(null); }}
              onDrop={(e) => {
                e.preventDefault();
                setDropTarget(null);
                if (!isLast) onDropTo?.(crumb.path);
              }}
            >
              {crumb.name}
            </Link>
          </span>
        );
      })}
    </nav>
  );
}
